<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" scrollable persistent width="100%">
      <v-form class="fill-word" ref="form" v-model="valid" v-on:submit.prevent="validate">
        <v-card>
          <v-toolbar flat dark color="primary">
            <v-toolbar-title>
              <v-icon left>notes</v-icon>เพิ่มข้อสอบ (คำบรรยาย)
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon dark @click="close" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">ปิดหน้าต่าง</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" :lg="12" :md="12" :sm="12">
                <div class="rowContentmange pa-3">
                  <v-row class="mb-10">
                    <v-col :lg="12" :md="12" :sm="12" class="px-10">
                      <p class="title">
                        โจทย์
                        <span class="red--text">*</span>
                      </p>
                      <quill-editor
                        required
                        class="editor"
                        v-model="question"
                        :rules="questionRules"
                        clearable
                        ref="question"
                      />
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col :lg="6" :md="6" :sm="12" class="px-10">
                      <v-alert class="mt-6 title" text type="info" border="left">
                        <strong class="font-weight-bold">คำแนะนำ</strong>
                        <strong class="font-weight-bold">
                          <label class="headExplan">"</label>การระบุคะแนน
                          <label class="headExplan">"</label>
                        </strong>
                        <br />จะเป็นการกำหนดคะแนนเต็มของข้อนี้
                        <v-divider class="my-3"></v-divider>
                        <strong class="font-weight-bold">คำแนะนำ </strong>
                        <strong class="font-weight-bold">
                          <label class="headExplan">"</label>การกำหนดเปอร์เซ็นต์ความถูกต้องที่คาดหวัง
                          <label class="headExplan">"</label>
                        </strong>
                        <br /> จะเป็นการตรวจสอบประโยคของชุดคำตอบที่กำหนด และคำตอบของผู้ทำข้อสอบ เมื่อระบบตรวจสอบรูปประโยคมีความตรงกันตามเปอร์เซ็นต์ความถูกต้องที่กำหนด ผู้ทำข้อสอบจะได้คะแนนตามที่ระบุไว้ข้างต้น
                      </v-alert>
                    </v-col>
                    <v-col :lg="6" :md="6" :sm="12" class="px-10">
                      <p class="title">
                        คะแนน
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        outlined
                        type="number"
                        maxlength="10"
                        rounded
                        v-model="question_score"
                        :rules="scoreRules"
                        placeholder="คะแนน"
                        required
                        clearable
                        min="0"
                        @change="checkMinQuestionScore"
                      ></v-text-field>
                      <p class="title">
                        เปอร์เซ็นต์ความถูกต้องที่คาดหวัง
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        outlined
                        type="number"
                        rounded
                        v-model="percentScore"
                        maxlength="3"
                        :rules="percentRules"
                        placeholder="เปอร์เซ็นต์ความถูกต้อง"
                        required
                        clearable
                        append-outer-icon="mdi-percent"
                        prepend-inner-icon=">"
                        class="percentScoreTextField"
                        min="0"
                        @change="checkMinPercentScore"
                      ></v-text-field>
                    </v-col>
                  </v-row>-->
                  <v-row class="px-8 mb-12">
                    <v-col lg="6" md="6" sm="6" cols="12">
                      <div class="d-flex mb-2">
                        <p class="title">เสียงประกอบโจทย์ (ไม่บังคับ)</p>

                        <v-btn
                          class="ml-auto"
                          rounded
                          color="error"
                          v-if="audio_id"
                          @click="deletemedia('audio')"
                        >
                          <v-icon left>mdi-delete</v-icon>ลบ
                        </v-btn>
                      </div>
                      <v-card v-if="audio_id" height="100%" outlined>
                        <div class="w-md-50 center-panel">
                          <vuetify-audio
                            :file="audio_url"
                            color="primary"
                            :audioPlaying.sync="audioPlaying"
                          ></vuetify-audio>
                        </div>
                      </v-card>
                      <v-card height="200" outlined v-if="audio_id === null">
                        <div class="text-center center-panel">
                          <v-btn
                            outlined
                            rounded
                            color="blue-grey"
                            @click="openMediaDialog('audio')"
                          >
                            <v-icon left>mdi-volume-high</v-icon>เพิ่มเสียง
                          </v-btn>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col lg="6" md="6" sm="6" cols="12">
                      <div class="d-flex mb-2">
                        <p class="title">วิดีโอประกอบโจทย์ (ไม่บังคับ)</p>
                        <v-btn
                          class="ml-auto"
                          rounded
                          color="error"
                          v-if="video_id"
                          @click="deletemedia('video')"
                        >
                          <v-icon left>mdi-delete</v-icon>ลบ
                        </v-btn>
                      </div>
                      <v-card height="200" outlined v-if="video_id === null">
                        <div class="text-center center-panel">
                          <v-btn
                            outlined
                            rounded
                            color="blue-grey"
                            @click="openMediaDialog('video')"
                          >
                            <v-icon left>mdi-video</v-icon>เพิ่มวิดีโอ
                          </v-btn>
                        </div>
                      </v-card>
                      <v-card class="pa-5" height="100%" outlined v-if="video_id">
                        <div class="videoPlayer">
                          <video-player
                            class="video-player-box videoContainer"
                            ref="videoPlayer"
                            :options="playerOptions"
                            :playsinline="true"
                            customEventName="customstatechangedeventname"
                            @ready="playerReadied"
                          ></video-player>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row class="d-flex align-center mb-6 mx-5 px-10 title">
                    <v-col :lg="8" :md="8" :sm="8">
                      <p class="text-center">
                        ชุดคำตอบที่ใช้ตรวจสอบ
                        <span class="red--text">*</span>
                      </p>
                    </v-col>
                    <v-col :lg="2" :md="2" :sm="2">
                      <p class="text-center">
                        คะแนน
                        <span class="red--text">*</span>
                      </p>
                    </v-col>
                    <v-col :lg="2" :md="2" :sm="2">
                      <p class="text-center">ลบคำตอบ</p>
                    </v-col>
                  </v-row>
                  <div v-for="(row, index) in answer" :key="index">
                    <v-row
                      class="d-flex align-center my-0 mx-10 px-10 lecture-card"
                    >
                      <v-col cols="8" :lg="8" :md="8" :sm="8">
                        <p class="title">คีย์เวิร์ด (keyword) ที่ {{(index+1)}}</p>
                        <v-text-field
                          outlined
                          rounded
                          v-model="answer[index]"
                          ref="answer"
                          :value="answer[index]"
                          :rules="answerRules"
                          placeholder="คำตอบที่ใช้ตรวจสอบความถูกต้อง"
                          required
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          class="mt-12"
                          type="number"
                          rounded
                          outlined
                          :rules="scoreRules"
                          clearable
                          required
                          placeholder="คะแนน"
                          v-model="keywordScore[index]"
                          min="0"
                          @change="checkMinScore(choiceIndex)"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" sm="2">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              class="btn-style"
                              color="error"
                              fab
                              small
                              fill
                              @click="removeRow(index)"
                              :disabled="answer.length<=1"
                            >
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span class="subtitle-1">ลบคำตอบ</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <br />
                  </div>
                  <v-row justify="center">
                    <v-btn
                      width="15%"
                      class="title"
                      rounded
                      x-large
                      color="primary"
                      @click="addRowAnswer"
                      dark
                    >
                      <v-icon left>mdi-plus</v-icon>เพิ่มคำตอบ
                    </v-btn>
                  </v-row>
                  <v-divider class="my-5"></v-divider>
                  <v-row class="d-flex align-center mb-6 mx-10 px-10 lecture-card">
                    <v-col>
                      <p class="title">คำอธิบายเฉลย</p>
                      <quill-editor
                        class="editor"
                        :rules="answerDescriptionRules"
                        v-model="answer_description"
                        ref="answer_description"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              min-width="15%"
              color="grey darken-1"
              class="title my-2 mx-3"
              large
              dark
              rounded
              outlined
              @click="close"
            >ยกเลิก</v-btn>
            <v-btn
              min-width="15%"
              class="title my-2 mx-3"
              color="primary"
              large
              rounded
              @click="validate"
              :disabled="!validationForm()"
            >บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <insert-media-dialog
      :isMediaOpen.sync="mediaDialog"
      :isMediaClose="closeMediaDialog"
      :on-set-video="setVideo"
      :on-set-audio="setAudio"
      :typeMedia.sync="mediaType"
    ></insert-media-dialog>
  </v-row>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

import {
  insertQuestion,
  getQuestionById,
  updateQuestion
} from "@/service/course/exam";

import insertMediaDialog from "@/views/course/dialog/insertMediaDialog.vue";
import { serverName } from "@/service/configApi";
import { getPrivateVideo } from "@/service/upload/upload.js";

import videojs from "video.js";
window.videojs = videojs;
import $ from "jquery";
import { getPrivateFile } from "@/service/upload/upload.js";

// hls plugin for videojs6
require("videojs-contrib-hls/dist/videojs-contrib-hls.js");

export default {
  props: {
    isLectureOpen: {
      type: Boolean
    },
    isOpen: {
      type: Boolean
    },
    examId: {
      type: String
    },
    questionId: {
      type: String
    },
    questionType: {
      type: String
    },
    questions: {},
    articleId: {
      type: String
    },
    lectureId: {
      type: String
    },
    lectures: {
      type: Array
    },
    sectionId: {
      type: String
    },
    reorderLecture: {
      type: Function
    },
    closeDialog: {
      type: Function
    }
  },
  data() {
    return {
      valid: true,
      dialog: false,
      dialog_fillWord: false,
      notifications: false,
      sound: true,
      widgets: false,
      question: "",
      // question_score: "",
      answer: [""],
      keywordScore: [],
      answer_description: "",
      // nameRules: [v => !!v || "กรุณากรอกคะแนน"],
      rows: [1],
      chars: [],
      answer_select: [],
      answer_correct: 0,
      questionRules: [v => !!v || "กรุณากรอกโจทย์"],
      answerDescriptionRules: [v => !!v || "กรุณากรอกคำอธิบายเฉลย"],
      scoreRules: [
        v => !!v || "กรุณากรอกคะแนน",
        v => v > 0 || "Score must be more than 0"
      ],
      percentRules: [
        v => !!v || "กรุณากรอกเปอร์เซ็นต์ความถูกต้อง",
        v => (v >= 0 && v <= 100) || "เปอร์เซ็นต์ความถูกต้องมีค่าระหว่าง 0-100"
      ],
      answerRules: [v => !!v || "กรุณากรอกคำตอบที่ใช้ตรวจสอบความถูกต้อง"],
      percentScore: 0,
      editorOption: {},
      // audio
      audio_url: "",

      // mediaDialog
      mediaDialog: false,
      audio_id: null,
      video_id: null,

      playerOptions: {
        // videojs options
        fluid: true,
        height: "500",
        hls: true,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src:
              "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }
        ]
      },
      successUpload: false,
      isCheckComplete: false,
      urlVideo:
        "http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8",
      cantGetLink: false,
      showUploadPercent: false,
      mediaType: "",
      audioPlaying: false
    };
  },
  components: {
    insertMediaDialog,
    // VuetifyAudio: () => import("vuetify-audio"),
    VuetifyAudio: () => import("@/components/vuetify-audio"),
    videoPlayer
  },
  watch: {
    isOpen: async function(newValue) {
      if (newValue) {
        if (this.questionId) {
          let result = await getQuestionById({ id: this.questionId });
          this.oldQuestion = result;
          this.question = result.question;
          this.keywordScore = result.arrayScore;
          // this.question_score = result.score;
          this.answer = result.correctText;
          this.answer_description = result.note;

          this.percentScore = result.persentCorrectText;
          this.audio_id = result.audio;
          this.video_id = result.video;

          this.audio_id ? this.getAudioPreview() : "";
          this.video_id ? this.getPreview("video") : "";
        } else {
          this.valid = true;
          this.dialog_1 = false;
          this.question = "";
          // this.question_score = "";
          this.keywordScore = [];
          this.percentScore = "";
          this.answer_description = "";
          this.answer = [""];
          this.oldQuestion = {};
          this.chars = [];
          this.answer_select = [];
          this.answer_correct = 0;
          this.audio_id = null;
          this.video_id = null;
          // this.$refs.form.reset();
          this.$refs.form.resetValidation();
        }
      } else {
        try {
          // $(".videoPlayer")[0].player.pause();
          $("video").each(function() {
            $(this)
              .get(0)
              .pause();
          });
        } catch (error) {
          console.log(error);
        }
        try {
          this.audio_url = "";
          this.audioPlaying = false;
          // $('#player')[0].pause();
          // $('#player')[0].currentTime = 0;
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  methods: {
    addRowAnswer: function() {
      this.answer.push("");
      // this.keywordScore.push(0);
    },
    removeRow: function(index) {
      if (this.answer.length > 1) {
        this.answer.splice(index, 1);
        this.keywordScore.splice(index, 1);
      }
    },
    validationForm() {
      let bool = true;
      this.answer.forEach(item => {
        if (item && item.length < 1) {
          bool = false;
        }
      });
      return this.valid && this.question != "" && bool;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        let question = {
          idexam: this.examId,
          typeQuestion: "descriptive",
          question: this.question,
          correctText: this.answer,
          arrayScore: this.keywordScore,
          // persentCorrectText: this.percentScore,
          note: this.answer_description,
          randomChoice: false,
          video: this.video_id,
          audio: this.audio_id
          // score: this.question_score
        };
        if (this.articleId) {
          question = {
            ...question,
            articleQuestion: this.articleId
          };
        }

        if (this.questionId) {
          let resultQuestion = await updateQuestion({
            id: this.questionId,
            ...this.oldQuestion,
            ...question
          });
          console.log(resultQuestion);
        } else {
          let resultQuestion = await insertQuestion(question);
          console.log(resultQuestion);
        }
        await this.close();
      } else {
        console.log("not pass");
      }
    },
    // checkMinQuestionScore() {
    //   if (this.question_score < 0) this.question_score = 0;
    // },
    checkMinPercentScore() {
      if (this.percentScore < 0) this.percentScore = 0;
    },
    async close() {
      this.closeDialog();
      this.$refs.form.resetValidation();
    },
    async closeMediaDialog() {
      this.mediaDialog = false;
      //this.registerTutoralert = true;
    },
    setVideo(data) {
      this.video_id = data;
      this.getPreview("video");
    },
    setAudio(data) {
      this.audio_id = data;
      this.getAudioPreview();
    },
    async getAudioPreview() {
      this.audio_url = await getPrivateFile(this.audio_id);
      if (this.audio_url) {
        this.isCheckComplete = true;
        this.audioPlaying = true;
      }
    },
    async getPreview(type) {
      let resultLink = await getPrivateVideo(
        type == "audio" ? this.audio_id : this.video_id
      );
      if (resultLink.isCheckComplete !== undefined) {
        this.isCheckComplete = resultLink.isCheckComplete;
        if (resultLink.isCheckComplete) {
          type == "audio"
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  "x-session-token"
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.url
          // (this.urlVideo = resultLink.url);
          // this.oldVideoUrl = resultLink.url
          this.audioPlaying = true;
        } else {
          type == "audio"
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  "x-session-token"
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.urllocalhost

          this.audioPlaying = true;
        }

        //this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink}`;
        // this.successUpload = true;
        // this.pendingUpload = false;
      }
    },
    deletemedia(type) {
      type == "audio" ? (this.audio_id = null) : (this.video_id = null);
    },
    openMediaDialog(type) {
      type == "audio" ? (this.mediaType = "audio") : (this.mediaType = "video");
      this.mediaDialog = true;
    }
  },
  beforeMount() {
    this.chars = "abcdefghijklmnopqrstuvwxyz".split("");
  }
};
</script>
<style>
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.radioStyle {
  position: absolute;
  margin: 20px;
  padding: 80px;
}
.removeStyle {
  margin-top: 120px;
  margin-left: 80px;
}
.btn-style {
  margin-left: 120px;
  margin-right: 120px;
}
.btn-add-style {
  margin-left: 45px;
  margin-right: 45px;
}
.card-style:focus {
  border-color: #1976d2;
  box-shadow: 0 0 3px 0px #1976d2;
  /* background-color: white; */
  background-color: #1976d2;
}
.card-border {
  border-radius: 28px;
}

p {
  margin: 0 0 5px;
}

.manageButton {
  justify-content: flex-end;
}
.editorQuestion {
  height: 100px;
  margin-bottom: 70px;
}

.fill-word .editor_answer .ql-container {
  min-height: 90px;
}

.fill-word .textField {
  width: 100%;
}

.fill-word .editor .ql-container {
  min-height: 150px;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
  .btn-style {
    margin-left: 60px;
    margin-right: 60px;
  }
  .btn-add-style {
    margin-left: 22.5px;
    margin-right: 22.5px;
  }
}
</style>